import { render, staticRenderFns } from "./DashboardReport.vue?vue&type=template&id=e82c9504&scoped=true"
import script from "./DashboardReport.vue?vue&type=script&lang=js"
export * from "./DashboardReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82c9504",
  null
  
)

export default component.exports